export default __webpack_public_path__ + "static/media/ic-group-12.8b36fe29.svg";